// extracted by mini-css-extract-plugin
var _1 = "BirdviewCardDragHandle-moduledragHandle__HQMZG IconNG-moduleiconContainer__SxWZ0";
export { _1 as "dragHandle" }
